import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SystemSiteService } from 'app/services/system-site.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-info-news-detail',
  templateUrl: './info-news-detail.component.html',
  styleUrls: ['./info-news-detail.component.scss']
})
export class InfoNewsDetailComponent {

  Data: any = [];

  newsSubscription: Subscription = null;
  parameterSubscription: Subscription = null;

  public result_message = ""
  constructor(private systemSiteService: SystemSiteService, private router: Router,private route: ActivatedRoute) { }



  ngOnInit() {
    this.parameterSubscription = this.route.params.subscribe(params => {
      this.newsSubscription = this.systemSiteService.get_news(params._id).subscribe({
        next: (data) => {
          console.log(data.result_data)
          this.Data = data.result_data;
  
        },
        error: (error) => { console.log(error) },
      })
    });





  }

  ngOnDestroy(): void {
    if (this.newsSubscription)
      this.newsSubscription.unsubscribe();
      if (this.parameterSubscription)
      this.parameterSubscription.unsubscribe();
  }



}